/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkTransferAliasToMainAccount} from '../api'

export const useMutationBulkTransferAliasToMainAccount = createReactQueryMutationHook('bulkTransferAliasToMainAccount', bulkTransferAliasToMainAccount)
